import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import type { ReactNode } from 'react';
import styles from './Drawer.module.css';

export interface DrawerProps {
  open: boolean;
  onClose: () => void;
  wide?: boolean;
  header: ReactNode;
  children: ReactNode;
}

export function Drawer({ open, onClose, wide, header, children }: DrawerProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  return createPortal(
    <>
      <div className={`${styles.backdrop} ${open ? styles.open : ''}`} onClick={onClose} />
      <aside className={`${styles.drawer} ${open ? styles.open : ''} ${wide ? styles.wide : ''}`}>
        {header}
        <div className={styles.scroll}>{children}</div>
      </aside>
    </>,
    document.body,
  );
}

export const drawerStyles = styles;
